/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CashFlowForecastDetailsDto } from './cash-flow-forecast-details.dto';
import { CashFlowForecastDetailsMapper } from './cash-flow-forecast.mapper';

@Injectable()
export class CashFlowForecastRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  init(): Observable<CashFlowForecastDetailsDto> {
    return this.httpGet(`${this.bp}/manager/cash-forecast`, CashFlowForecastDetailsMapper);
  }

  update(details: CashFlowForecastDetailsDto): Observable<CashFlowForecastDetailsDto> {
    return this.httpPut(`${this.bp}/manager/cash-forecast`, details, CashFlowForecastDetailsMapper);
  }
}
